import { defineComponent as n, openBlock as o, createBlock as r, unref as v, mergeProps as l, withCtx as m, createElementVNode as p } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const h = /* @__PURE__ */ n({
  name: "IconPaintBrush",
  __name: "IconPaintBrush",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const t = a;
    return (s, e) => (o(), r(v(i), l(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        p("path", {
          "fill-rule": "evenodd",
          d: "m6.038 9.125.003-.25a10.3 10.3 0 0 0-.67-3.762C4.908 3.86 5.731 2.375 7.066 2.375H16.5a1.5 1.5 0 0 1 1.5 1.5v5.25a1.25 1.25 0 0 1 1.25 1.25v2a1.25 1.25 0 0 1-1.25 1.25h-3.25v5.75a2.25 2.25 0 0 1-2.25 2.25h-1a2.25 2.25 0 0 1-2.25-2.25v-5.75H6a1.25 1.25 0 0 1-1.25-1.25v-2A1.25 1.25 0 0 1 6 9.125h.038M15 3.875h1.5v5.25H7.499C7.486 8.01 7.377 6.21 6.778 4.592a.66.66 0 0 1 .054-.55C6.92 3.895 7.007 3.875 7.066 3.875H13.5v1.75a.75.75 0 0 0 1.5 0v-1.75m-4.25 9.75h2.5v5.75a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-5.75m7-1.5H6.25v-1.5h11.5v1.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  h as default
};
